/*eslint-disable*/
import IntervalConfig from './IntervalConfig';

export default {
    durations: [
        0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10
    ],
    digits: IntervalConfig.digits,
    seconds: IntervalConfig.seconds
}